import { AXBasePageComponent } from '@acorex/components/page';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Component, ElementRef, EventEmitter, Inject, Input, Output, PLATFORM_ID, ViewChild, ViewEncapsulation } from '@angular/core';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// import * as L from 'leaflet';
import { LeafletService } from './leaflet.service';

@Component({
  selector: 'travel-btc-workspace-public-map',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './public-map.component.html',
  styleUrl: './public-map.component.scss',
  encapsulation: ViewEncapsulation.None,
  providers: [LeafletService],
})
export class PublicMapComponent extends AXBasePageComponent implements AfterViewInit {
  private map!: any;
  private marker = {};
  private markerIcon: any;

  @ViewChild('map') mapElement!: ElementRef;

  @Input() allowMark = false;

  @Input()
  markers: any[] = [32.664812573810615, 51.648788452148445];
  // markers !: any;

  @Input()
  centerLocation = [32.664812573810615, 51.648788452148445];

  @Output() clickOnMap: EventEmitter<any> = new EventEmitter<any>();

  @Input()
  zoom = 15;

  constructor(private leafletService: LeafletService, @Inject(PLATFORM_ID) private platformId: any) {
    super();
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      const container = this.leafletService.L.DomUtil.get('map');
      setTimeout(() => {
        if (container != null) {
          container._leaflet_id = null;
        }
        this.initMap();
        if (this.allowMark) {
          this.map.on('click', (e: any) => {
            this.addMarker(e);
          });
        }
      }, 500);
    }
  }

  private initMap(): void {
    this.markerIcon = this.leafletService.L.icon({
      iconUrl: './assets/images/marker.png',
      iconSize: [59, 57],
      iconAnchor: [30, 57],
      popupAnchor: [-3, -76],
    });

    const tiles = this.leafletService.L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 20,
    });

    this.map = this.leafletService.L.map('map', {
      center: this.centerLocation,
      zoom: this.zoom,
    });

    tiles.addTo(this.map);
    if (this.markers.length !== 0) {
      this.addMarker(this.markers);
    }
    this.showMarkers();
  }

  addMarker(e: any) {
    if (this.marker) {
      this.map.removeLayer(this.marker as any);
    }
    this.marker = this.leafletService.L.marker(e.latlng ? e.latlng : e, {
      icon: this.markerIcon,
    }).addTo(this.map);
    this.clickOnMap.emit(e);
  }
  showMarkers() {
    if (this.markers.length) {
      this.marker = new this.leafletService.L.marker([this.markers[0], this.markers[1]], {
        icon: this.markerIcon,
      })
        .bindPopup(this.markers[0])
        .addTo(this.map);
    }
  }

  getUserLocation() {
    this.map.setView(this.centerLocation as any, 12);
    this.map
      .locate({ setView: true, watch: true, maxZoom: 30 })
      .on('locationfound', (e: any) => {
        this.addMarker(e);
      })
      .on('locationerror', (e: any) => {
        alert(`Location access denied ${e}`);
      });
  }
}
